"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageComponent = void 0;
const services_1 = require("../../../services");
const pdfTheme_1 = require("../pdfTheme");
class ImageComponent {
    constructor(imageReference, availableWidth, availableHeight = pdfTheme_1.pdfTheme.page.height) {
        this.imageReference = imageReference;
        this.availableWidth = availableWidth;
        this.availableHeight = availableHeight;
    }
    exportContent() {
        if (!this.imageReference.timeStamp) {
            return {
                image: this.imageReference.reference,
                fit: [this.availableWidth, this.availableHeight],
            };
        }
        const dateString = services_1.Services.DateTime.formatDate(this.imageReference.timeStamp.toISOString());
        const fontSize = (14 * this.availableWidth) / pdfTheme_1.pdfTheme.page.width;
        const rect = {
            type: 'rect',
            x: 0,
            y: 0,
            w: this.availableWidth / 4,
            h: fontSize * 1.5,
            color: pdfTheme_1.pdfTheme.background.default,
            fillOpacity: 0.8,
        };
        return {
            /**
             *  because we dont know how the image is going to be scaled
             *  centering is the easiest way to line up the text and its background
             */
            alignment: 'center',
            unbreakable: true,
            stack: [
                {
                    image: this.imageReference.reference,
                    fit: [this.availableWidth, this.availableHeight],
                    alignment: 'center',
                },
                ...(this.imageReference.timeStamp && [
                    {
                        relativePosition: {
                            x: 0,
                            y: -fontSize * 1.5,
                        },
                        canvas: [rect],
                    },
                    {
                        text: dateString,
                        style: ['dateText'],
                        fontSize,
                        relativePosition: {
                            x: 0,
                            y: -fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER,
                        },
                    },
                ]),
            ],
        };
    }
    exportStyles() {
        // NOTE: This value will also determine the y position of the table and date text above ^^^
        return {
            dateText: {
                color: pdfTheme_1.pdfTheme.font.color.dark,
            },
        };
    }
}
exports.ImageComponent = ImageComponent;
//# sourceMappingURL=ImageComponent.js.map